import { curry } from '@cvent/carina-utils';
export var getStepIndex = curry(function (steps, stepID) {
    return steps.findIndex(function (step) { return step.id === stepID; });
});
